import React from 'react';
import {  Grid } from '@mui/material';
import Layout from '../components/Layout';
import { DashboardTotalbilled } from '../components/DashboardTotalbilled';
import { DashboardTopServices } from '../components/DashboardTopServices';
import { DashboardTopPets } from '../components/DashboardTopPets';
import { DashboardDuration } from '../components/DashboardDuration';

const Dashboard = () => {

  return (

    <Layout >
      <Grid container spacing={2}>
        <Grid item size={{ xs: 12 , md: 6}}>
          <DashboardTotalbilled/>
        </Grid>

        <Grid item size={{ xs: 12 , md: 6}}>
          <DashboardTopServices />
        </Grid>

        <Grid item size={{ xs: 12 , md: 6}}>
          <DashboardTopPets />
        </Grid>

        <Grid item size={{ xs: 12 , md: 6}}>
          <DashboardDuration />
        </Grid>
      </Grid>
    </Layout>

  );
};

export default Dashboard;
